import styled from 'styled-components/macro';

import { Title } from '@olist/design-system';
import { tokens } from '@olist/design-system-tokens';

const CustomTitle = styled(Title)`
  margin-bottom: ${tokens.spacing[500]};
  text-align: center;
`;

export default CustomTitle;
